module.exports = {
	"RECOMMEND": "RECOMMEND",
	"RP_H5": "RP_H5",
	"RP_SPA": "RP_SPA",
	"RP_VIDEO": "RP_VIDEO",
	"RP_GAME": "RP_GAME",
	"SHOWPAGE": "SHOWPAGE",
	"OPENEDPAGE": "OPENEDPAGE",
	"CHAJIAN": "CHAJIAN",
	"OPENZONE": "OPENZONE",
	"OPENEDPLUGIN": "OPENEDPLUGIN",
	"POSTER": "POSTER",
	"VIP": "VIP",
	"ENTERPRISE": "ENTERPRISE",
	"MY_TPL": "MY_TPL",
	"SEARCH": "SEARCH",
	"MY_COLLECTION": "MY_COLLECTION",
	"LOCAL_TEMPLATE": "LOCAL_TEMPLATE",
	"RP_STORE": "RP_STORE",
	"PREVIEW_MODAL": "PREVIEW_MODAL",
	"PREVIEW_VIDEO_MODAL": "PREVIEW_VIDEO_MODAL",
	"PREVIEW_GAME_MODAL": "PREVIEW_GAME_MODAL",
	"SUCCESS": "SUCCESS",
	"ERROR": "ERROR",
	"SHOW_BY_URL": "SHOW_BY_URL",
	"CORNER_TYPE": {
		"RECOMMEND_TOP10": "推荐TOP10",
		"NEW_TOP10": "新品TOP10",
		"FIRST_AWARD": "设计一等奖",
		"TWO_AWARD": "设计二等奖",
		"THREE_AWARD": "设计三等奖",
		"EXCELLENT_AWARD": "设计优秀奖",
		"AWARD": "AWARD",
		"RECOMMEND": "RECOMMEND"
	},
	"CORNER_SELECT": {
		"AWARD": "DESIGN_ALL",
		"TOP": "TOP10_ALL",
		"ALL": "ALL"
	},
	"CORNER_TITLE": {
		"AWARD": "设计大赛",
		"RECOMMEND": "推荐TOP10"
	},
	"BLOCKED_CODE": [
		101,
		102,
		103,
		104,
		105,
		106,
		107,
		108,
		109
	],
	"BLOCKED_TEXT": {
		"CREATE": "账户已被冻结或封禁，不支持作品创建",
		"EIDTOR": "账户已被冻结或封禁，不支持作品修改",
		"PAY": "账户已被冻结或封禁，不支持购买支付"
	},
	"PLUGIN": "plugin",
	"MOSTHOT": "mostHot",
	"TPLSPECIES": "tplSpecies",
	"NORMAL": "normal",
	"ALL": "ALL",
	"CONTENT_TYPE": {
		"SHOW_PAGE": "showPage",
		"ACTIVITY_PAGE": "activityPage",
		"VIDEO": "video",
		"POSTER": "poster"
	}
}